// extracted by mini-css-extract-plugin
module.exports = {"Container":"style_Container__tKJ7t","FlagPlaceholder":"style_FlagPlaceholder__4_KaH"};